import { BlockStack, SkeletonDisplayText } from '@shopify/polaris';
import __helpers from 'helpers/index';
import 'media/css/DriverRevenueTimeline.scss';
import { useGetTrip_manifest_due_date } from 'queries/trip_manifest.query';

export default function DriverRevenueTimeline() {
  const { data, isLoading } = useGetTrip_manifest_due_date();
  return (
    <div className="driver-revenue-timeline">
      <div className="driver-revenue-timeline__legend">
        <div className="driver-revenue-timeline__legend-item">
          <span className="driver-revenue-timeline__dot driver-revenue-timeline__dot--due" />
          <span>Phải thu</span>
        </div>

        <div className="driver-revenue-timeline__legend-item">
          <span className="driver-revenue-timeline__dot driver-revenue-timeline__dot--collected" />
          <span>Đã thu</span>
        </div>
      </div>

      <div className="driver-revenue-timeline__body">
        {isLoading ? (
          <BlockStack gap="400">
            <SkeletonDisplayText />
            <SkeletonDisplayText />
          </BlockStack>
        ) : null}
        {data &&
          data.map((item) => (
            <div className="driver-revenue-timeline__day" key={item.key}>
              <div className="driver-revenue-timeline__top">
                <div className="driver-revenue-timeline__amount driver-revenue-timeline__amount--due">
                  {__helpers.formatNumberWithCommas(item.due)}
                </div>
              </div>

              <div className="driver-revenue-timeline__center">
                <div className="driver-revenue-timeline__line" />
                <div className="driver-revenue-timeline__point" />
                <div className="driver-revenue-timeline__date">{item.date}</div>
              </div>

              <div className="driver-revenue-timeline__bottom">
                <div className="driver-revenue-timeline__amount driver-revenue-timeline__amount--collected">
                  {__helpers.formatNumberWithCommas(item.collected)}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

